export default __webpack_public_path__ + "static/media/slice-app-large.6eda7506.jpg";